<template>
    <b-modal ref="pwa_settings"
             size="xl"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <template v-slot:modal-header="{ close }">
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>

        <div id="panel_users_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">PWA Settings</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="p-2" >
                <b-overlay :show="is_load" rounded="sm" >
                    <b-tabs content-class="mt-3" >
                        <b-tab v-for="(tab,index) in tabs" @click="set_active(index)"
                               :disabled="tab.disabled"
                               :title="get_tab_title(tab)"
                               :key="index"
                               :active="tab.is_active"
                        >
                            <template slot="title">
                                {{get_tab_title(tab)}}
                            </template>

                            <component
                                @onChange="onChangeParam"
                                :user="user"
                                :pwa="pwa_settings" v-bind:is="tab.index">
                            </component>
                        </b-tab>
                    </b-tabs>
                </b-overlay>
            </div>

        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" v-on:click="close_modal" class="btn btn-secondary waves-effect waves-themed">
                    {{__t("CLOSE")}}
                </button>

                <button type="button" v-on:click="save_settings" class="btn btn-primary waves-effect waves-themed">
                    {{__t("SAVE")}}
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>

import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
});

import pwa_main_info from "./tabs/pwa_main_info";
import pwa_images from "./tabs/pwa_images";
import pwa_color from "./tabs/pwa_color";

import g_map from "./tabs/google/g_map";
import pwa_social from "./tabs/social/pwa_social.vue";
import pwa_seo from "./tabs/seo/pwa_seo.vue";
import pwa_texts from "./tabs/pwa_texts.vue";
import pwa_double_currency_tab from "./tabs/double_currency/pwa_double_currency_tab.vue";


export default {
    name: "pwa_settings_modal",

    components : {
        pwa_main_info,
        pwa_images,
        g_map,
        pwa_color,
        pwa_social,
        pwa_seo,
        pwa_texts,
        pwa_double_currency_tab
    },

    data() {
        return {
            is_show_modal : false,
            is_load : false,
            pwa_settings : {
                colors : {
                    primary_color : "#194d33",
                    secondary_color : "#ff7f23",
                    color_scheme : "light",
                },
                articles : {
                    "description" : "",
                    "about_company" : "",
                    "conditions" : "",
                    "privacy" : "",
                    'delivery' : "",
                },
                geo : {
                    "default_geo_radius" : 3,
                    "default_delivery_price"  : 0,
                    'default_delivery_time' : 30,
                    "default_delivery_min_price" : 0,
                },

                social : {
                    'fb_link' : "",
                    'insta_link' : "",
                    'youtube_link' : "",
                    'tiktok_link' : ""
                },

                seo : {
                    "pixel_code" : "",
                    "gtag_code" : "",
                    "google_measurement_key" : "",
                    "tiktok_code" : "",
                    "meta_key"  : "",
                    'no_index' : true,
                },
                double_currency : {
                    "has_double_currency" : false,
                    "double_currency_id" : 0,
                    "cross_currency" : 0,
                },

                sms_auth:  false,
                is_geo_on : false,
                use_estimate : false,
                pay_table : false,
                pay_bonus : true,
                show_contact_form : true,
                show_catalog_stop : true,
              //  show_reservation : true,
                allow_install : true,
                bonus_max_percent : 100,
                phones : "",
                main_discount_org : null,
                base_url : "",
                base_url_type : "in_segment",
            },
            tabs : [
                {
                    "icon" : "fa-user",
                    'index' : "pwa_main_info",
                    'title' : "Main"
                },
                {
                    "icon" : "fa-user",
                    'index' : "pwa_images",
                    'title' : "Images"
                },
                {
                    "icon" : "fa-user",
                    'index' : "pwa_color",
                    'title' : "Color"
                },

                {
                    "icon" : "fa-user",
                    'index' : "pwa_texts",
                    'title' : "Articles"
                },

                /*{
                    "icon" : "fa-user",
                    'index' : "pwa_article_about",
                    'title' : "About Company"
                },
                {
                    "icon" : "fa-user",
                    'index' : "pwa_article_delivery",
                    'title' : "Delivery"
                },
                {
                    "icon" : "fa-user",
                    'index' : "pwa_article_conditions",
                    'title' : "Conditions"
                },
                {
                    "icon" : "fa-user",
                    'index' : "pwa_article_privacy",
                    'title' : "Privacy"
                },*/
                {
                    "icon" : "fa-user",
                    'index' : "pwa_social",
                    'title' : "Social Networks"
                },

                {
                    "icon" : "fa-user",
                    'index' : "pwa_seo",
                    'title' : "Seo Settings"
                },


                {
                    "icon" : "fa-user",
                    'index' : "pwa_double_currency_tab",
                    'title' : "Double Currency"
                },


                /*{
                    "icon" : "fa-user",
                    'index' : "g_map",
                    'title' : "Google Map"
                }*/
            ],
        }
    },

    created() {
        EventBus.$on('show_pwa_settings',this.load_settings);
        EventBus.$on('profile_loaded',this.set_user);

    },

    methods : {

        onChangeParam(type,val) {

        },

        async load_pwa_settings() {
            this.is_load = true;

            agr_api.get('/aggregators/pwa/general_settings').then(({data}) => {
                this.is_load = false;
                if (data.status == "operation_success") {
                    let resp = data.data;

                    console.log(resp);

                    this.push_color_settings(resp);
                    this.push_articles_settings(resp);
                    this.push_social_settings(resp);
                    this.push_geo_settings(resp);
                    this.push_seo_settings(resp);
                    this.push_double_currency(resp);

                    if(resp.hasOwnProperty("payments")) {
                        this.pwa_settings.payments = resp.payments;
                    }

                    if(resp.hasOwnProperty('phones')) {
                        this.pwa_settings.phones = resp.phones;
                    }

                    if(resp.hasOwnProperty('base_url')) {
                        this.pwa_settings.base_url = resp.base_url;
                    }

                    if(resp.hasOwnProperty('base_url_type')) {
                        this.pwa_settings.base_url_type = resp.base_url_type;
                    }


                    EventBus.$emit('pwa_settings_loaded');
                }
            })	.catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: this.__t("POSTER_GET_VER")
                })
            });
        },

        push_double_currency(resp) {
            if(resp.hasOwnProperty("has_double_currency")) {
                this.pwa_settings.double_currency.has_double_currency = resp.has_double_currency;
            }

            if(resp.hasOwnProperty("cross_currency")) {
                this.pwa_settings.double_currency.cross_currency = resp.cross_currency;
            }

            if(resp.hasOwnProperty("double_currency_id")) {
                this.pwa_settings.double_currency.double_currency_id = resp.double_currency_id;
            }
        },

        push_seo_settings(resp) {
            if(resp.hasOwnProperty("pixel_code")) {
                this.pwa_settings.seo.pixel_code = resp.pixel_code;
            }

            if(resp.hasOwnProperty("gtag_code")) {
                this.pwa_settings.seo.gtag_code = resp.gtag_code;
            }

            if(resp.hasOwnProperty("google_measurement_key")) {
                this.pwa_settings.seo.google_measurement_key = resp.google_measurement_key;
            }

            if(resp.hasOwnProperty("ga_code")) {
                this.pwa_settings.seo.ga_code = resp.ga_code;
            }

            if(resp.hasOwnProperty("tiktok_code")) {
                this.pwa_settings.seo.tiktok_code = resp.tiktok_code;
            }

            if(resp.hasOwnProperty("meta_key")) {
                this.pwa_settings.seo.meta_key = resp.meta_key;
            }


            if(resp.hasOwnProperty("seo_title")) {
                this.pwa_settings.seo.seo_title = resp.seo_title;
            }

            if(resp.hasOwnProperty("seo_description")) {
                this.pwa_settings.seo.seo_description = resp.seo_description;
            }

            if(resp.hasOwnProperty("no_index")) {
                this.pwa_settings.seo.no_index = resp.no_index;
            }

        },

        push_geo_settings(resp) {
            if(resp.hasOwnProperty("google_key")) {
                this.pwa_settings.google_key = resp.google_key;
            }

            if(resp.hasOwnProperty("main_discount_org")) {
                this.pwa_settings.main_discount_org = resp.main_discount_org;
            }

            if(resp.hasOwnProperty('use_estimate')) {
                this.pwa_settings.use_estimate = resp.use_estimate;
            }

            if(resp.hasOwnProperty('call_geo')) {
                this.pwa_settings.is_geo_on = resp.call_geo;
            }

            if(resp.hasOwnProperty('sms_auth')) {
                this.pwa_settings.sms_auth = resp.sms_auth;
            }

            if(resp.hasOwnProperty('pay_table')) {
                this.pwa_settings.pay_table = resp.pay_table;
            }

            if(resp.hasOwnProperty('allow_install')) {
                this.pwa_settings.allow_install = resp.allow_install;
            }

           /* if(resp.hasOwnProperty('show_reservation')) {
                this.pwa_settings.show_reservation = resp.show_reservation;
            }*/

            if(resp.hasOwnProperty('show_contact_form')) {
                this.pwa_settings.show_contact_form = resp.show_contact_form;
            }

            if(resp.hasOwnProperty("show_catalog_stop")) {
                this.pwa_settings.show_catalog_stop = resp.show_catalog_stop;
            }


            if(resp.hasOwnProperty('pay_bonus')) {
                this.pwa_settings.pay_bonus = resp.pay_bonus;
            }

            if(resp.hasOwnProperty('bonus_max_percent')) {
                this.pwa_settings.bonus_max_percent = resp.bonus_max_percent;
            }


            if(resp.hasOwnProperty('default_geo_radius')) {
                this.pwa_settings.geo.default_geo_radius = resp.default_geo_radius;
            }

            if(resp.hasOwnProperty('default_delivery_price')) {
                this.pwa_settings.geo.default_delivery_price = resp.default_delivery_price;
            }

            if(resp.hasOwnProperty('default_delivery_min_price')) {
                this.pwa_settings.geo.default_delivery_min_price = resp.default_delivery_min_price;
            }

            if(resp.hasOwnProperty('default_delivery_time')) {
                this.pwa_settings.geo.default_delivery_time = resp.default_delivery_time;
            }
        },


        push_social_settings(resp) {

            if(resp.hasOwnProperty('youtube_link')) {
                this.pwa_settings.social.youtube_link = resp.youtube_link;
            }

            if(resp.hasOwnProperty('tiktok_link')) {
                this.pwa_settings.social.tiktok_link = resp.tiktok_link;
            }

            if(resp.hasOwnProperty('insta_link')) {
                this.pwa_settings.social.insta_link = resp.insta_link;
            }

            if(resp.hasOwnProperty('fb_link')) {
                this.pwa_settings.social.fb_link = resp.fb_link;
            }
        },

        push_articles_settings(resp) {

            if(resp.hasOwnProperty("about_company")) {
                this.pwa_settings.articles.about_company = resp.about_company;
            }

            if(resp.hasOwnProperty("privacy")) {
                this.pwa_settings.articles.privacy = resp.privacy;
            }

            if(resp.hasOwnProperty("conditions")) {
                this.pwa_settings.articles.conditions = resp.conditions;
            }

            if(resp.hasOwnProperty("delivery")) {
                this.pwa_settings.articles.delivery = resp.delivery;
            }

            if(resp.hasOwnProperty("description")) {
                this.pwa_settings.articles.description = resp.description;
            }
        },

        push_color_settings(resp) {

            if(resp.hasOwnProperty("primary_color")) {
                this.pwa_settings.colors.primary_color = resp.primary_color;
            }

            if(resp.hasOwnProperty("secondary_color")) {
                this.pwa_settings.colors.secondary_color = resp.secondary_color;
            }

            if(resp.hasOwnProperty("color_scheme")) {
                this.pwa_settings.colors.color_scheme = resp.color_scheme;
            }
        },


        pushSettingsFromResp() {

        },


        async load_settings() {
            this.is_show_modal = true;
            this.is_load = true;
            this.$store.dispatch('user/LOAD_FULL_USER');
            this.load_pwa_settings();
        },

        set_user() {
            this.is_load = false;
        },

        save_settings() {
            this.is_load = true;
            agr_api.put('/aggregators/pwa/general_settings',this.pwa_settings).then(({data}) => {
                this.is_load = false;
                this.close();

            })	.catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: this.__t("PWA_ERR")
                })
            });
        },


        close_modal () {
            this.close();
        },
        close() {
            this.is_show_modal = false;
        },

        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },

        set_active (obj) {
            for (let tab in this.tabs) {
                this.tabs[tab].is_active = false;
            }

            this.tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
        },

    },

    computed: {
        ...mapFields([
            'user',
            'module'
        ]),

        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }

            return "modal-dialog-right modal-lg";
        },
    }

}
</script>

<style scoped>

</style>
